export const getDiscountCodeName = (code: string): string => {
  if (code.startsWith("CUSTOM-")) return "Custom";

  return code;
};
